export function getPartnerPmsList(partner) {
  const credentials = partner?.integrationCredentials;
  if (Array.isArray(credentials)) {
    const integrations = [
      ...new Set(credentials.map((ic) => ic?.integration).filter(Boolean)),
    ];
    if (integrations.length > 0) return integrations;
  }
  return partner?.propertyManagementSystem
    ? [partner.propertyManagementSystem]
    : [];
}

export function hasPms(partner, vendor) {
  return getPartnerPmsList(partner).includes(vendor?.toLowerCase());
}

export function hasAnyPms(partner, vendors) {
  const list = getPartnerPmsList(partner);
  return vendors.some((v) => list.includes(v?.toLowerCase()));
}
